import { html } from '@microsoft/fast-element';

export default html`
	<div inert class="filter" part="filter"></div>
	<div class="image-container" part="image-container">
		<slot></slot>
	</div>
`;